import React from 'react'
import { SchoolChart } from './SchoolChart'
import { STYLES } from '../../static/style'

interface ISchoolResultsChartProps {
  title: string
  fieldName: string
  color?: string
  results?: object
  className?: string
  options?: object
}

const SchoolResultsChart: React.FC<ISchoolResultsChartProps> = ({
  title,
  results,
  fieldName,
  options = {
    plugins: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
      legend: {
        display: false,
      },
      bezierCurve: false,
      tooltipTemplate: '<%= value %>',
    },
  },
  className,
  color = STYLES.COLOR_ALANTIS_GREEN,
}) => (
  <SchoolChart
    title={title}
    results={results}
    fieldName={fieldName}
    options={options}
    className={className}
    color={color}
  />
)

export { SchoolResultsChart }
